"use strict";

var _classCallCheck = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _get = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/get");

var _inherits = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var HTMLElementImpl = require("./HTMLElement-impl").implementation;

var idlUtils = require("../generated/utils");

var closest = require("../helpers/traversal").closest;

var createDOMTokenList = require("../dom-token-list").create;

var resetDOMTokenList = require("../dom-token-list").reset;

var HTMLTableCellImpl = /*#__PURE__*/function (_HTMLElementImpl) {
  _inherits(HTMLTableCellImpl, _HTMLElementImpl);

  function HTMLTableCellImpl() {
    _classCallCheck(this, HTMLTableCellImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(HTMLTableCellImpl).apply(this, arguments));
  }

  _createClass(HTMLTableCellImpl, [{
    key: "_attrModified",
    value: function _attrModified(name, value, oldValue) {
      if (name === "headers" && this._headers) {
        resetDOMTokenList(this._headers, value);
      }

      _get(_getPrototypeOf(HTMLTableCellImpl.prototype), "_attrModified", this).call(this, name, value, oldValue);
    }
  }, {
    key: "headers",
    get: function get() {
      if (this._headers === undefined) {
        this._headers = createDOMTokenList(this, "headers");
      }

      return this._headers;
    }
  }, {
    key: "cellIndex",
    get: function get() {
      var tr = closest(this, "tr");

      if (tr === null) {
        return -1;
      }

      return Array.prototype.indexOf.call(tr.cells, idlUtils.wrapperForImpl(this));
    }
  }, {
    key: "colSpan",
    get: function get() {
      var value = this.getAttribute("colspan");
      return value === null ? 1 : value;
    },
    set: function set(V) {
      this.setAttribute("colspan", String(V));
    }
  }, {
    key: "rowSpan",
    get: function get() {
      var value = this.getAttribute("rowspan");
      return value === null ? 1 : value;
    },
    set: function set(V) {
      this.setAttribute("rowspan", String(V));
    }
  }]);

  return HTMLTableCellImpl;
}(HTMLElementImpl);

module.exports = {
  implementation: HTMLTableCellImpl
};